import ShieldIcon from "@/svg/ShieldIcon.tsx";
import st from "@/styles/Ui.module.scss"
import {useTranslation} from "react-i18next";
import {useEffect, useRef} from "react";
import {useNavigate} from "react-router-dom";
import DashboardClass from "@/utils/dashboard_class.ts";
import useAuth from "@/hooks/auth.ts";
import useNotifications from "@/hooks/notifications.ts";
import {useAtom} from "jotai/index";
import {pending_loans} from "@/atoms/common.ts";
import Button from "@/ui/Button.tsx";

const SuccessKYC = () => {
    const {t} = useTranslation()
    const navigate = useNavigate()
    const auth = useAuth()
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    const notif = useNotifications()
    const [loans] = useAtom(pending_loans)
    const redirectTimeout = useRef<ReturnType<typeof setTimeout> | null>(null)


    const updates = async () => {
        notif.upd_technical()

        auth.updateProfile()

        const timeout = setTimeout(() => {
            auth.updateProfile()
            clearTimeout(timeout)
        }, 3000)
    }

    const goHome = () => {
        if(redirectTimeout.current) clearTimeout(redirectTimeout.current)
        navigate(DashboardClass.dashboard_routes.Home)
    }

    useEffect(() => {

        updates()

    }, []);

    useEffect(() => {

        if(
            typeof loans === "object" &&
            Object.keys(loans).length &&
            (
                loans.hasOwnProperty("approved_and_need_sign") ||
                loans.hasOwnProperty("approved_and_not_verified") ||
                loans.hasOwnProperty("approved_and_not_valid_data") ||
                loans.hasOwnProperty("more_data_and_verified")
            )
        ){
            redirectTimeout.current = setTimeout(() => {
                if(debug === "true") console.info("setInterval SuccessKYC")

                navigate(DashboardClass.dashboard_routes.PendingLoans)
            }, 3000)

        } else {
            redirectTimeout.current = setTimeout(() => {
                if(debug === "true") console.info("setInterval SuccessKYC")

                navigate(DashboardClass.dashboard_routes.Home)
            }, 3000)
        }

        return () => {
            if(redirectTimeout.current) clearTimeout(redirectTimeout.current)
        }

    }, [loans]);

    return (
        <section className={st.success_kyc}>
            <ShieldIcon />
            <strong>
                {t("success_kyc")}
            </strong>
            <Button onClick={goHome}>
                {t("main_page")}
            </Button>
        </section>
    )
}

export default SuccessKYC